import script from "./BaseContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseContainer.vue?vue&type=script&setup=true&lang=ts"

import "./BaseContainer.vue?vue&type=style&index=0&id=759b0d64&lang=scss"

const __exports__ = script;

export default __exports__